export default __webpack_public_path__ + "static/media/gabriel-seaver.d05a2baf.jpg";